import H7 from '@base/H7/H7';
import styled from '@emotion/styled';
import { Spacings, Fonts } from '@styles/index';
import Image from '@base/Image';

const BatchStatusWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  margin-top: ${Spacings.SPACING_4B};
`;

const BatchStatusText = styled(H7)`
  margin-left: ${Spacings.SPACING_1B};
  color: var(--color-i-red);
  font-size: ${Fonts.SMALL};
`;
const ImageWrapper = styled.div`
  height: ${Spacings.SPACING_5B};
  width: ${Spacings.SPACING_5B};
`;

const BatchStatus = ({ stateMetaInfo = {}, isEnrolled }) => {
  if (isEnrolled || !stateMetaInfo?.text || !stateMetaInfo?.icon) {
    return null;
  }

  const { text, icon } = stateMetaInfo;
  return (
    <BatchStatusWrapper>
      {icon && (
        <ImageWrapper>
          <Image src={icon} alt="clock" width={20} height={20} />
        </ImageWrapper>
      )}
      {text && <BatchStatusText>{text}</BatchStatusText>}
    </BatchStatusWrapper>
  );
};
export default BatchStatus;
